<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Районы
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'district-add' }">+ Добавить район</router-link>
    </h1>

    <resource-list
      url="/districts"
      current-sort="name"
      resource-name="districts"
      :show-per-page="false"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'districts',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'name', label: 'Название', sort: true },
        { name: 'addresses_count', label: 'Кол-во адресов', sort: false },
        { name: 'buildings_count', label: 'Кол-во домов', sort: false },
        { name: 'blocks_count', label: 'Кол-во подъездов', sort: false },
        { name: 'apartments_count', label: 'Кол-во квартир', sort: false }
      ],
      filters: {
        city: this.$route.params.city_id
      },
      actionRoutes: [
        { name: 'district-details', idName: 'district_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// Districts.vue?1e8677e0